// src/pages/AddSubtype.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { useNavigate } from "react-router-dom";
import { api } from "../components/Api";

export default function AddSubtype() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        type_id: "",
        subtype_name: "",
        subtype_ref: "",
    });
    const [types, setTypes] = useState([]);
    const [existingRefs, setExistingRefs] = useState([]);
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    // Récupération des types et des sous-types existants
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resTypes = await api.get("/types");
                setTypes(resTypes.data);

                const resSubtypes = await api.get("/subtypes");
                const refs = resSubtypes.data.map(st => st.subtype_ref);
                setExistingRefs(refs);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des données.");
            }
        };
        fetchData();
    }, []);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let { type_id, subtype_name, subtype_ref } = form;

        // Convertir la référence en majuscule
        subtype_ref = subtype_ref.toUpperCase();

        // Vérifications front
        if (!type_id) return alert("Veuillez sélectionner un type.");
        if (!subtype_name.trim()) return alert("Le nom du sous-type est obligatoire.");
        if (!subtype_ref.match(/^[A-Z]{2}$/)) return alert("La référence doit être exactement 2 lettres majuscules.");
        if (subtype_ref === "XX") return alert("La référence XX n’est pas autorisée.");
        if (existingRefs.includes(subtype_ref)) return alert("Cette référence est déjà utilisée.");

        try {
            await api.post("/subtypes", { type_id, subtype_name, subtype_ref });
            alert("Sous-type ajouté avec succès !");
            navigate("/subtype-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout du sous-type.");
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Ajouter un Sous-Type</h1>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="type_id" className="block font-medium mb-1">Type :</label>
                    <select
                        id="type_id"
                        name="type_id"
                        value={form.type_id}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    >
                        <option value="">-- Sélectionnez un type --</option>
                        {types.map(t => (
                            <option key={t.id} value={t.id}>{t.type_name}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="subtype_name" className="block font-medium mb-1">Nom du sous-type :</label>
                    <input
                        type="text"
                        id="subtype_name"
                        name="subtype_name"
                        value={form.subtype_name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <div>
                    <label htmlFor="subtype_ref" className="block font-medium mb-1">Référence :</label>
                    <input
                        type="text"
                        id="subtype_ref"
                        name="subtype_ref"
                        value={form.subtype_ref}
                        onChange={handleChange}
                        maxLength={2}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                    <p className="text-sm text-gray-500 mt-1">
                        Deux lettres non utilisées, XX interdit.
                    </p>
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
